module.exports = __webpack_public_path__ + "img/fb445ae.png";